import axios from 'axios'
import Qs from 'qs'
import wx from 'weixin-js-sdk';

import {getServer} from '@/utils/share'
import {setStore, getStore, removeStore} from '@/config/mUtils'
import {APPID} from '@/service/getData';
//提示弹窗
import Vue from 'vue'
import {Alert} from '@/wc-messagebox'
Vue.use(Alert);


/**
 * 获取链接参数
 */
export const GetQueryString = (name) => {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
};




/**
 * 调用微信授权
 */
export const getWxAuth = (callback) => {
  let appId = APPID;

  const query = Qs.parse(location.hash.substring(3));
  let code = query.code || GetQueryString("code") || "";
  let state = query.state || GetQueryString("state") || "";
  let appKey = query.appKey || GetQueryString("appKey") || "";

  if(appKey){
    appKey = encodeURIComponent(appKey)
  }
  if (code == "" || code == null || code == "undefined") {
    Vue.prototype.$alert({
      title: '微信授权',
      content: '请点击下方【允许】按钮，完成授权使用完整服务',
      btnText: '允许',
      style: 'color:#3CC51F;font-weight:bold;'
    }).then(function(res){
      if(res == 'ok') {

        let locaurl_base = location.href.split('#')[0].split('?')[0];
        //let locaurl_base = encodeURIComponent(location.href);
        //window.location = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + appId + "&redirect_uri=" + locaurl_base + "&response_type=code&scope=snsapi_userinfo&state="+ appKey +"&connect_redirect=1#wechat_redirect";
        window.location.replace("https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + appId + "&redirect_uri=" + locaurl_base + "&response_type=code&scope=snsapi_userinfo&state="+ appKey +"&connect_redirect=1#wechat_redirect")
      }
    });

  } else {
    axios.post( getServer().admin + 'getUserInfo.wap' , Qs.stringify({code: code}), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'appKey': state
      }
    }).then(function (data) {
      if (callback) callback(data)
    });

  }

};





// WEBPACK FOOTER //
// ./src/utils/author.js